/* 🤖 this file was generated by svg-to-ts */
export const iconPlay: {
    name: 'play';
    data: string;
} = {
    name: 'play',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20"><path fill="#000" fill-rule="evenodd" d="M.662 1.285v17.43c0 .55.61.879 1.07.577l13.294-8.714a.69.69 0 0 0 0-1.156L1.732.708a.69.69 0 0 0-1.07.577m1.381 16.151V2.563L13.387 10z"/></svg>`
};
